module.exports = __webpack_public_path__ + "img/862ae5d36a0054b24b4524e3896e44a0.png";